export enum ESpinnerColor {
  light,
  dark,
}
